import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import { SelectBoxProps } from 'src/constants/Interface';

type Props = SelectBoxProps & {
  showDefaultOption?: boolean;
  disabled?: boolean;
  color?: 'green';
  isError: boolean;
};

const SelectBox = ({ ...props }: Props) => {
  const {
    id,
    inputValue,
    showDefaultOption,
    disabled,
    placeholder,
    color,
    options,
    onChange,
    isError,
  } = props;

  return (
    <Styled isError={isError}>
      <select
        is={id}
        value={inputValue}
        disabled={disabled ? true : undefined}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      >
        {showDefaultOption && (
          <option disabled value="">
            {placeholder || '----'}
          </option>
        )}
        {options.map((n, idx) => {
          return (
            <option key={idx} value={n.value}>
              {n.content}
            </option>
          );
        })}
      </select>
      <span className={`icon ${color ? `is-${color}` : ''}`}></span>
    </Styled>
  );
};

SelectBox.defaultProps = {
  showDefaultOption: true,
  disabled: false,
  bordered: false,
  isError: false,
};

const Styled = styled.div<{ isError: boolean }>`
  position: relative;
  box-sizing: border-box;
  > select {
    width: 100%;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid
      ${({ isError }) => (isError ? StyleConfig.COLOR.SECONDORY : StyleConfig.COLOR.INPUT_BORDER)} !important;
    padding: 12px;
    color: '#000';
    font-size: 16px;
    line-height: 1;
    height: 52px;
    &.is-border {
      border: 1px solid ${StyleConfig.COLOR.INPUT_BORDER} !important;
    }
    option[disabled] {
      color: ${StyleConfig.COLOR.TEXT_GRAY};
    }
    &[disabled] {
      background-color: ${StyleConfig.COLOR.INPUT_BORDER};
      cursor: not-allowed;
    }
  }
  .icon {
    position: absolute;
    top: 0;
    right: ${StyleConfig.HELPER.M16};
    bottom: 0;
    width: 10px;
    content: '';
    display: block;
    height: 20px;
    margin: auto;
    background-image: url('/images/icon/pulldown.png');
    background-size: cover;
    touch-action: none;
    pointer-events: none;

    &.is-green {
      background-image: url('/images/icon/pulldown_g.svg');
    }
  }
`;

export default SelectBox;
